import PropTypes from 'prop-types';

export const opportunityItemPropType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  agencyName: PropTypes.string,
  type: PropTypes.string,
  registrationDate: PropTypes.string,
});

export const pursuitPropType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
});

export const pursuitOpportunityItemPropType = PropTypes.shape({
  type: PropTypes.string,
  opportunityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

export const NOT_INTERESTED_SECTION_BY_TYPE = {
  contract: 'FCO',
  award: 'CA',
  grant: 'FGO',
  nsn: 'NSN',
  stateLocal: 'SLCO',
  stateLocalForecast: 'SLCF',
  stateLocalAward: 'SLCA',
};
